var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ssTosPapers) {pug_html = pug_html + "\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flegals\u002Fimg\u002Fpaper-icon-7fbf3db90a.svg\" alt=\"\" data-no-retina=\"\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EIdentity Platform Terms of Service\u003C\u002Fh1\u003E\u003Cp\u003EThis page provides Auth0's Identity Platform Terms of Service for its Free, Developer, Developer Pro, Open Source Program, Startup Program and other Customers. (These Terms do not apply to Auth0's Enterprise Customers)\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003Csection class=\"editable-subscriptions-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-md-12 content\"\u003E\u003Cdiv class=\"content-section\"\u003E\u003Ch4\u003EDocuments\u003C\u002Fh4\u003E";
// iterate ssTosPapers
;(function(){
  var $$obj = ssTosPapers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cul class=\"section-paper-list\"\u003E";
// iterate item.papers
;(function(){
  var $$obj = item.papers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var itemPaper = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli" + (" class=\"paper\""+pug.attr("id", itemPaper.id, true, true)) + "\u003E\u003Cdiv class=\"paper-description\"\u003E\u003Cimg" + (" class=\"icon-paper-file\""+pug.attr("src", itemPaper.icon, true, true)+" alt=\"File\"") + "\u003E\u003Cdiv class=\"description\"\u003E\u003Cdiv class=\"description-title truncate\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"description-date\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.date) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"paper-actions\"\u003E";
// iterate itemPaper.actions
;(function(){
  var $$obj = itemPaper.actions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var itemPaperActions = $$obj[pug_index2];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var itemPaperActions = $$obj[pug_index2];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var itemPaper = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli" + (" class=\"paper\""+pug.attr("id", itemPaper.id, true, true)) + "\u003E\u003Cdiv class=\"paper-description\"\u003E\u003Cimg" + (" class=\"icon-paper-file\""+pug.attr("src", itemPaper.icon, true, true)+" alt=\"File\"") + "\u003E\u003Cdiv class=\"description\"\u003E\u003Cdiv class=\"description-title truncate\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"description-date\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.date) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"paper-actions\"\u003E";
// iterate itemPaper.actions
;(function(){
  var $$obj = itemPaper.actions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var itemPaperActions = $$obj[pug_index3];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var itemPaperActions = $$obj[pug_index3];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cul class=\"section-paper-list\"\u003E";
// iterate item.papers
;(function(){
  var $$obj = item.papers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var itemPaper = $$obj[pug_index4];
pug_html = pug_html + "\u003Cli" + (" class=\"paper\""+pug.attr("id", itemPaper.id, true, true)) + "\u003E\u003Cdiv class=\"paper-description\"\u003E\u003Cimg" + (" class=\"icon-paper-file\""+pug.attr("src", itemPaper.icon, true, true)+" alt=\"File\"") + "\u003E\u003Cdiv class=\"description\"\u003E\u003Cdiv class=\"description-title truncate\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"description-date\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.date) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"paper-actions\"\u003E";
// iterate itemPaper.actions
;(function(){
  var $$obj = itemPaper.actions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var itemPaperActions = $$obj[pug_index5];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var itemPaperActions = $$obj[pug_index5];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var itemPaper = $$obj[pug_index4];
pug_html = pug_html + "\u003Cli" + (" class=\"paper\""+pug.attr("id", itemPaper.id, true, true)) + "\u003E\u003Cdiv class=\"paper-description\"\u003E\u003Cimg" + (" class=\"icon-paper-file\""+pug.attr("src", itemPaper.icon, true, true)+" alt=\"File\"") + "\u003E\u003Cdiv class=\"description\"\u003E\u003Cdiv class=\"description-title truncate\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"description-date\"\u003E" + (pug.escape(null == (pug_interp = itemPaper.date) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"paper-actions\"\u003E";
// iterate itemPaper.actions
;(function(){
  var $$obj = itemPaper.actions;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var itemPaperActions = $$obj[pug_index6];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var itemPaperActions = $$obj[pug_index6];
if ((itemPaperActions.action == "download")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+pug.attr("download", true, true, true)) + "\u003EDownload\u003C\u002Fa\u003E";
}
else
if ((itemPaperActions.action == "open")) {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EOpen\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"action\""+pug.attr("href", itemPaperActions.file, true, true)+" target=\"_blank\"") + "\u003EAction\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"ssTosPapers" in locals_for_with?locals_for_with.ssTosPapers:typeof ssTosPapers!=="undefined"?ssTosPapers:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/ss-tos/pages/ss-tos-page.pug
// module id = 1335
// module chunks = 0